import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=a375d740&scoped=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=a375d740&prod&lang=css"
import style1 from "./ProfileDetails.vue?vue&type=style&index=1&id=a375d740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a375d740",
  null
  
)

export default component.exports